import LearningModuleItem from "./LearningModuleItems";

const LearningModules = ({ modules }) => {
  return (
    <div className="col-md-8 mb-4">
      <div className="rounded-lg border border-primary">
        <div className="p-4">
          <h4 className="text-light fw-bold mb-4">Learning Modules</h4>

          {modules.map((module, idx) => (
            <LearningModuleItem
              key={idx}
              index={idx + 1}
              title={module.title}
              duration={module.duration}
              progress={module.progress}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LearningModules;